import { render, staticRenderFns } from "./modal_edit.vue?vue&type=template&id=6b5754cc&"
import script from "./modal_edit.vue?vue&type=script&lang=js&"
export * from "./modal_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports